import React, { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import EditForm from '../../../../../../features/components/Forms/EditForm'
import MultipleGoogleMediaUpload from '../../../GoogleAssetGroup/GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { useEditSectionFormSubmit } from '../../../../../../hooks/formHooks/useEditSectionFormSubmit'

import { updateAd } from '../../../../../../modules/actions/ads'
import { selectedGoogleAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { getInitialValues, validationSchema } from './fields'
import { getImageAssets, LANDSCAPE_IMAGE, landscapeImageHeight, landscapeImageWidth } from '../../../fields'
import { GOOGLE_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { landscapeImageValidationSchema } from '../../../validations'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

const LandscapeImageSectionForm = ({ editItemData: ad, successSubmit, isInternalAd, title, ...formProps }) => {
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)

  const { id, ad_account_id: adAccountId } = ad
  const adAccount = adAccountId || selectedAdAccountId

  const initialValues = useMemo(() => getInitialValues(ad), [ad])

  const handleSubmit = useCallback(
    values => {
      dispatch(
        updateAd(
          {
            account: adAccount,
            responsive_display_ad: {
              marketing_images: getImageAssets(values[LANDSCAPE_IMAGE])
            },
            ...(isInternalAd && { internal: true }),
            meta: {
              [HISTORY_META_EDIT_SECTION]: title
            }
          },
          id,
          GOOGLE_PLATFORM
        )
      )
    },
    [dispatch, id, isInternalAd, adAccount, title]
  )

  const { onSubmit, manualSuccessSubmit } = useEditSectionFormSubmit({ initialValues, handleSubmit })

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true
  })

  const purifiedFormik = usePurifiedFormik(formik)

  const { values } = purifiedFormik

  const isEmptyList = !values[LANDSCAPE_IMAGE].length

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={successSubmit || manualSuccessSubmit}
      {...formProps}
    >
      <MultipleGoogleMediaUpload
        formik={purifiedFormik}
        FileItemPath={LANDSCAPE_IMAGE}
        validationSchema={landscapeImageValidationSchema}
        addAnotherButtonText={isEmptyList ? 'Add landscape image' : 'Add another landscape image'}
        width={landscapeImageWidth}
        height={landscapeImageHeight}
      />
    </EditForm>
  )
}

export default LandscapeImageSectionForm
